export default __webpack_public_path__ + "static/media/img-services.99af8d8a.jpg";